import module from '../module';

function OrderContactViewDirective($scope, messageService,groupOrderService) {

    function setFirstLetter(contact) {
        if (!contact.isGroup) {
            let name = contact.name || contact.email || "-";
            contact.firstLetter = name.substring(0, 1);
        }
    }

    $scope.toggleContact = function (contact) {
        if (contact.forcedSelected) {
            return;
        }
        contact.selected = !contact.selected;
        if (contact.selected) {
            contact.selectedOn = new Date();
        } else {
            contact.selectedOn = null;
        }
        $scope.onChanged();
    };

    $scope.expandCollapseGroup = function () {
        $scope.contact.expanded = !$scope.contact.expanded;
        $scope.onChanged();
    };

    this.$onInit = function () {
        setFirstLetter($scope.contact);

        if ($scope.contact.contacts) {
            $scope.contact.contacts.forEach(contact => setFirstLetter(contact));
        }
    };

    $scope.deleteContact = async (email) => {
        $scope.onContactDelete();
    }
}

OrderContactViewDirective.$inject = ['$scope','Message','GroupOrder'];

module.directive('cartonomyOrderContact', function () {
    return {
        scope: {
            contact: '=contact',
            onChanged: '&contactChanged',
            groupView: '=',
            onContactDelete: '&contactDelete'
        },
        templateUrl: 'modules/order/views/contactView.html',
        controller: OrderContactViewDirective
    };
});



// WEBPACK FOOTER //
// ./src/modules/order/directives/OrderContactViewDirective.js